const randomNumber = (n: number): number => Math.round(Math.random() * n)

export default {
  randomNumber,
}
